'use client';

import { useSelector } from 'react-redux';

import { appTypeSliceSelectors } from '@highlight-cp/redux-state';

const useIsAdminApp = () => useSelector(appTypeSliceSelectors.isAdminApp);

export default useIsAdminApp;
